<p-dialog
    (onHide)="onHide()"
    (onShow)="onShow()"
    [(visible)]="visible"
    [appendTo]="appendTo"
    [contentStyle]="contentStyle"
    [dismissableMask]="dismissOnClickOutside"
    [draggable]="draggable"
    [minX]="minX"
    [minY]="minY"
    [modal]="blockBackground"
>
    <ng-template #header>
        {{(existingApplication ? "applications.edit" : "applications.create") | translate}}
    </ng-template>

    @if (dialogForm) {
    <form
        class="p-16"
        id="manage_application_form"
        [formGroup]="dialogForm"
        autocomplete="off"
        novalidate
    >
        @if (existingApplication) {
        <div
            class="m-form-group row"
            [ngClass]="{ 'has-error': dialogForm.get('clientId').showErrors }"
        >
            <label
                class="col-2"
                for="clientId"
            >
                {{"applications.clientId" | translate}}
            </label>
            <div class="col-10">
                <input
                    class="p-inputtext"
                    id="clientId"
                    #clientIdInput
                    formControlName="clientId"
                    type="text"
                />
                <app-form-validation
                    [control]="dialogForm.get('clientId')"
                    [input]="clientIdInput"
                >
                </app-form-validation>
            </div>
        </div>
        } @if (dialogForm.get('userId')) {
        <div
            class="m-form-group row"
            [ngClass]="{ 'has-error': dialogForm.get('userId').showErrors }"
        >
            <label
                class="col-2"
                for="userId"
            >
                {{"general.user" | translate}}
            </label>
            <div class="col-10">
                <p-select
                    id="userId"
                    [filter]="true"
                    [options]="users"
                    [panelStyle]="{'width':'100%'}"
                    [resetFilterOnHide]="true"
                    [style]="{'width':'100%'}"
                    #userIdInput
                    formControlName="userId"
                >
                </p-select>
                <app-form-validation
                    [control]="dialogForm.get('userId')"
                    [input]="userIdInput"
                >
                </app-form-validation>
            </div>
        </div>
        }
        <div
            class="m-form-group row"
            [ngClass]="{ 'has-error': dialogForm.get('description').showErrors }"
        >
            <label
                class="col-2"
                for="description"
            >
                {{"general.description" | translate}}
            </label>
            <div class="col-10">
                <input
                    class="p-inputtext"
                    id="description"
                    #descriptionInput
                    appAutofocus
                    formControlName="description"
                    type="text"
                />
                <app-form-validation
                    [control]="dialogForm.get('description')"
                    [input]="descriptionInput"
                >
                </app-form-validation>
            </div>
        </div>
        <div
            class="row"
            [formGroup]="rightsForm"
        >
            @for (groupedRight of groupedRights; track groupedRightTrackByFn($index, groupedRight)) {
            <div class="col-4 mt-16">
                <h3
                    class="mb-8"
                    (click)="selectGroup(groupedRight)"
                >
                    {{groupedRight.label}}
                </h3>
                <div>
                    <ul>
                        @for (right of groupedRight.rights; track rightTrackByFn($index, right)) {
                        <li>
                            <label class="m-input-checkbox">
                                <input
                                    formControlName="{{right.value}}"
                                    type="checkbox"
                                />
                                {{right.label}}
                            </label>
                        </li>
                        }
                    </ul>
                </div>
            </div>
            }
        </div>
    </form>
    }

    <ng-template #footer>
        <button
            class="m-btn m-btn-link"
            id="cancel_button"
            (click)="close()"
            [disabled]="submitting"
            type="button"
        >
            {{"form.cancel" | translate}}
        </button>

        <button
            class="m-btn m-btn-primary"
            id="save_button"
            (click)="submit()"
            [disabled]="submitting"
            type="submit"
        >
            @if (submitting) {
            <app-loading-spinner> </app-loading-spinner>
            } {{"form.save" | translate}}
        </button>
    </ng-template>
</p-dialog>
